import { Controller } from "@hotwired/stimulus"

// Warning treatment for an ordered line handed to someone inside the item's
// cooldown. The server stamps `overridden_by` on save and the row renders the
// border and icon from it on load, but a successful auto-save never re-renders
// the row — so the same treatment is applied here to be visible immediately.
export default class extends Controller {
  static targets = ["icon"]

  declare iconTarget: HTMLElement
  declare hasIconTarget: boolean

  mark() {
    this.element.classList.add("border-warning")
    // Inline display rather than a class: DaisyUI's .tooltip sets its own and
    // wins against `hidden`.
    if (this.hasIconTarget) this.iconTarget.style.display = ""
  }
}
